export default {
  experience: (param) => `profile/workexp?${buildQuery(param)}`,
  editexperience: "profile/workexp/update",
  postexperience: "profile/workexp",
  industryGroup: "profile/workexp/industryGroup",
  deleteexperience: (param) => `profile/workexp/destroy?${buildQuery(param)}`,
};

function buildQuery(param) {
  const query = new URLSearchParams(param);
  return query.toString();
}
